export const SERVER_URL = process.env.REACT_APP_SERVER_URL
// export const IS_PROD =
//   process.env.REACT_APP_IS_PROD === 'true' ||
//   process.env.REACT_APP_IS_PROD === '"true"' ||
//   process.env.REACT_APP_IS_PROD === "'true'"
export const IS_PROD = true
